var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-badge',{attrs:{"color":_vm.colorMap[_vm.status],"text":_vm.$t(("LadingErrorStatus." + (_vm.LadingErrorStatus[_vm.status])))}})}
var staticRenderFns = []

export { render, staticRenderFns }